import { ItemCustomLink } from "@dto/customLinks.dto";
import { ColorUtil } from "src/util/ColorUtil";
import { GLOB } from "src/util/Glob";

type SortableLink = Partial<Pick<ItemCustomLink, 'label' | 'color' | 'url'>>;
export const sortCustomLinks = <T extends SortableLink>(links: T[]): T[] =>
  links
    .map(link => ({ link, luminance: ColorUtil.luminance(link.color) }))
    .sort((a, b) =>
      GLOB.naturalSort(a.link.label ?? '', b.link.label ?? '')
      || b.luminance - a.luminance
      || GLOB.naturalSort(a.link.url ?? '', b.link.url ?? ''))
    .map(({ link }) => link);
